import keyCodes from '@utils/key-codes';

$(() => {
    const $dropdownInput = $('#findHospitalDropdownInput');
    const $input = $('#findHospitalText');
    const $search = $('#btn-find-hospital');

    const redirectUrl = $search.data('redirect');
    const query = $search.data('query') || 'text';
    const separator = $search.data('query-separator') || '?';

    const defaultParam = $search.data('query-default') ? `&${$search.data('query-default')}` : '';

    $input.on('keyup', function (event) {
        const key = event.which ? event.which : event.keyCode;
        if (key === keyCodes.ENTER) {
            event.preventDefault();
            $search.trigger('click');
        }
    });

    $search.on('click', function (event) {
        event.preventDefault();

        const searchText = $input.val();
        const categoryParam = $dropdownInput.val() && $dropdownInput.val()  !== 'allcategories' ? `&f:Species=[${$dropdownInput.val()}]` : '';
        const queryParam = `${query}=${searchText}`;

        location.href = redirectUrl + separator + queryParam + defaultParam + categoryParam;
    });
});
